<div class="toggle-wrapper" *ngIf="!(authStore.isRsaUser() | async)">
  <h2>
    {{ '+INSTALLATIONS.INSTALLATION.SRC.CONNECTION_STATUS.TITLE' | translate }}
  </h2>

  <vi-loader
    *ngIf="loading$ | async; else content"
    [isLoading]="true"
    [message]="'+USER_REGISTRATION.USER_REGISTRATION.LOADING_MESSAGES.DATA' | translate"
  ></vi-loader>

  <ng-template #content>
    <div class="flex flex-row items-center gap-4 mt-4">
      <p>
        {{ '+INSTALLATIONS.INSTALLATION.SRC.CONNECTION_STATUS.LOST_CONNECTION_LABEL' | translate }}
      </p>
      <mat-slide-toggle
        class="flex-grow"
        #lostConnectionToggle
        gtm="lostConnectionNotificationsToggle"
        gtmId="lost-connection-notifications-toggle"
        gtmAction="onToggleChange"
        [checked]="isEnabled$ | async"
        (change)="onToggleChange(lostConnectionToggle.checked)"
      >
      </mat-slide-toggle>
    </div>

    <p class="mt-2">
      {{ '+INSTALLATIONS.INSTALLATION.SRC.CONNECTION_STATUS.DESCRIPTION' | translate }}
    </p>

    <div class="flex flex-row items-center gap-4 mt-4">
      <p class="whitespace-nowrap">
        {{ '+INSTALLATIONS.INSTALLATION.SRC.CONNECTION_STATUS.DELAY_TIME_LABEL' | translate }}
      </p>
      <mat-form-field mat-select-height-small class="inline w-full">
        <mat-select
          [disabled]="!(isEnabled$ | async)"
          [value]="threshold$ | async"
          (selectionChange)="onDelayChange($event.value)"
        >
          <mat-option *ngFor="let option of delayOptions" [value]="option.value">
            {{ option.label | minutesOrHours }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-template>
</div>
